module.exports = function getResource(label, vars = []) {
    let resources = {
        sortBy: 'Trier par'
    };

    return resources[label];
};
